import React from "react";

import { MarketplaceFreeShippingTag } from "./MarketplaceFreeShippingTag";
import { OnePassFreeShippingTag } from "./OnePassFreeShippingTag";

interface ProductCardTagsProps {
  onePassEligible?: boolean;
  freeShippingAvailable?: boolean;
}

export const ProductCardTags = (props: ProductCardTagsProps) => {
  const { onePassEligible, freeShippingAvailable } = props;

  if (freeShippingAvailable) {
    return <MarketplaceFreeShippingTag />;
  }

  if (onePassEligible) {
    return <OnePassFreeShippingTag />;
  }

  return null;
};
